import { createContext, useReducer, useEffect } from "react";
import { AppReducer } from "./AppReducer";
import { db } from "../firebase";

const initialState = {
  photos: [],
};

// create context
export const GlobalContext = createContext(initialState);

// create context provider

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AppReducer, initialState);

  useEffect(() => {
    let unsubscribe = db.collection("photos").onSnapshot((snapshot) =>
      dispatch({
        type: "FETCH_DATA",
        payload: snapshot.docs.map((doc) => ({ id: doc.id, data: doc.data() })),
      })
    );

    return () => unsubscribe();
  }, []);

  return (
    <GlobalContext.Provider value={{ state }}>
      {children}
    </GlobalContext.Provider>
  );
};
